import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import OppurtunityService from "../Controller/OppurtunityController";
import CustomerService from "../../Customer/Controller/CustomerController";
import OppurtunityDetailModal from "./OppurtunityDetail";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import Common from '../../Common/Common';
import HelpSite from "../../Common/HelpLink";
import { handleChange, handleSubmit } from "../../Customer/Controller/CreateCustomerDetailController";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import { useTranslation } from 'react-i18next';
import SendEmail from "../../Common/SendEmail";
import ColumnOptionDropDown from "../../Lead/Views/LeadForms/ColumnOptionDropDown";
import Cookies from "js-cookie";
import QuotationService from "../../Quotation/Controller/QuotationController";
import QuotationSelectionModal from "./OpportunityForms/QuotationSelectionModal";
import { formatDateWithFns } from '../../Common/DateInputFormat';
import useDateFormat from '../../Common/fetchDateFormat';
import LockReleaseService from "../../Setup/controller/LockReleaseController/LockModuleController";
import MultipleEmail from "../../Common/MultipleEmail";
import UserDropdown from "../../Common/UserDropdown";
import LeadService from "../../Lead/Controller/LeadController"
import CustomerEmailingList from "../../Common/EmailingName";
import JasperReportService from '../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../config/axiosInstance';
import Draggable from 'react-draggable';
import MultiSearchDropDown from "../../Common/MultiSearchDropDown";
import InboxModal from "../../Common/InboxModal";
import ReportService from "../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../Setup/controller/TermsConditionController/TermsConditionController";
import BASE_URL from "../../../config/config";
import { PDFDocument } from "pdf-lib";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
import ImportTableService from "../../Setup/controller/ImportTables/ImportTable";
function LeadList() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const tableRef = useRef();
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [opportunityList, setOppurtunityData] = useState([]);
    const [modalInstanceLeadDetail, setModalInstanceLeadDetail] = useState(null);
    const [showLeadDetailModal, setShowLeadDetailModal] = useState(false); // State to control AssetDetailModal visibility
    const [loading, setLoading] = useState(true);
    const [selectedId, setSelectedId] = useState("0");
    const [multipleIds, setMultipleIds] = useState([]);
    const [errors, setErrors] = useState({});
    // Helper to get page size from cookie

    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);
    const [selectedUser, setSelectedUser] = useState("");
    const UserID = localStorage.getItem("UserID");
    const CompanyID = localStorage.getItem("CompanyID");
    const [emailName, setEmailName] = useState("");
    const setSortConfigInCookie = (config) => {
        Cookies.set(`OpportunitySort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`OpportunitySort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
    const activeDateFormat = useDateFormat();


    const [isModalOpen, setIsModalOpen] = useState(false);
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [Email, setEmail] = useState();
    const [opportunityIDForEmail, setOpportunityIDForEmail] = useState();
    const [quotationList, setQuotationList] = useState([]);
    const [QuotationModal, setQuotationModal] = useState(false);
    const [opporID, setOpportunityID] = useState("0");
    const [isMultipleEmailModalOpen, setIsMultipleEmailModalOpen] = useState(false);
    const [multipleEmails, setMultipleEmails] = useState([]);
    const [recentSearches, setRecentSearches] = useState([]);
    const [selectedRoleName, setRoleName] = useState(localStorage.getItem("RoleName"));
    async function fetchSearchLog() {
        try {

            const searchList = await CustomerService.GetSearchLog("18");
            setRecentSearches(searchList);
        } catch (error) {
            console.error('Error fetching Roles:', error);
        }
    }
    useEffect(() => {
        fetchOpportunity(currentPage, pageSize);
        fetchSearchLog();
    }, [currentPage, pageSize]);
    useEffect(() => {
        fetchOpportunity(sortConfig);
    }, [currentPage, pageSize]);
    const fetchOpportunity = async (page, size) => {
        try {

            setLoading(true);
            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            localStorage.setItem('OpportunityID', "");
            const oppurtunityData = await OppurtunityService.GetAllOppurtunities(redirectCallback, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), emailName.toString(), searchColumns.toString());
            setOppurtunityData(oppurtunityData);

            const leadCount = await OppurtunityService.GetOpportunityCount(redirectCallback, searchQuery, emailName.toString(), searchColumns.toString());
            setPOCount(leadCount[0].TotalRecords);
            setTotalPages(Math.ceil(leadCount[0].TotalRecords / size));

        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
        finally {
            setLoading(false); // Stop loading after fetching
        }
    };
    const UserLockRelease = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const CompanyID = localStorage.getItem("CompanyID");
            if (CompanyID === null || CompanyID === "null") {
                redirectCallback();
            }
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
            await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");

        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    useEffect(() => {
        IsModuleAssigned();
        UserLockRelease();
        fetchOpportunity("0", pageSize);
    }, []);

    const handleCreateOpportunityClick = () => {
        localStorage.setItem('OpportunityID', "");
        localStorage.setItem('OpportunityID', "0");
        localStorage.setItem('HasRecordUpdated', "0");

        setIsModalOpen(true);
    };



    const handleCloseModal = async (isChanged) => {

        const closeModal = async () => {
            await OppurtunityService.UnLockOpportunity(localStorage.getItem('OpportunityID'));
            if (localStorage.getItem('HasRecordUpdated') == "1") {
                fetchOpportunity("0", pageSize);
            }
            setMultipleIds([]);
            setIsModalOpen(false);
        };

        if (isChanged != true) {
            closeModal();
            return;
        }

        Swal.fire({
            title: 'Are you sure?',
            text: `Are you sure you want to close this record?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, close it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                closeModal();
            }
        });
    };


    const [shouldAutoSelect, setShouldAutoSelect] = useState(null);
    useEffect(() => {
        if (shouldAutoSelect && opportunityList.length > 0) {
            const leadToSelect =
                shouldAutoSelect === 'next'
                    ? opportunityList[0] // first item of new page
                    : opportunityList[opportunityList.length - 1]; // last item of previous page

            localStorage.setItem('OpportunityID', leadToSelect.ID);
            setSelectedId(leadToSelect.ID);
            setShouldAutoSelect(null); // reset
        }
    }, [opportunityList]);
    const handleNext = async (isChanged) => {


        const nextModal = async () => {
            const leadID = localStorage.getItem('OpportunityID');
            const currentIndex = opportunityList.findIndex(item => item.ID.toString() === leadID);
            await OppurtunityService.UnLockOpportunity(leadID);
            if (currentIndex < opportunityList.length - 1) {
                const nextLead = opportunityList[currentIndex + 1];
                localStorage.setItem('OpportunityID', nextLead.ID);
                setSelectedId(nextLead.ID);
            } else if (currentPage < totalPages) {
                setShouldAutoSelect('next'); // flag for useEffect
                setCurrentPage(prev => prev + 1);
            }
        };

        if (isChanged != true) {
            nextModal();
            return;
        }

        Swal.fire({
            title: 'Are you sure?',
            text: `Are you sure you want to go to next record?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then(async (result) => {
            if (result.isConfirmed) {
                nextModal();
            }
        });
    };

    const handlePrevious = async (isChanged) => {

        const prevModal = async () => {
            const leadID = localStorage.getItem('OpportunityID');
            const currentIndex = opportunityList.findIndex(item => item.ID.toString() === leadID);
            await OppurtunityService.UnLockOpportunity(leadID);
            if (currentIndex > 0) {
                const prevLead = opportunityList[currentIndex - 1];
                localStorage.setItem('OpportunityID', prevLead.ID);
                setSelectedId(prevLead.ID);
            } else if (currentPage > 1) {
                setShouldAutoSelect('previous'); // flag for useEffect
                setCurrentPage(prev => prev - 1);
            }
        };

        if (isChanged != true) {
            prevModal();
            return;
        }

        Swal.fire({
            title: 'Are you sure?',
            text: `Are you sure you want to go to previous record?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then(async (result) => {
            if (result.isConfirmed) {
                prevModal();
            }
        });
    };
    const handleEditClick = async (OpportunityID) => {
        const IsAlreadyLeadID = localStorage.getItem('OpportunityID');
        if (IsAlreadyLeadID) {
            await OppurtunityService.UnLockOpportunity(IsAlreadyLeadID);
        }

        const OpportunityDetail = await fetchOpportunityDetail(OpportunityID);
        if (OpportunityDetail) {
            localStorage.setItem('OpportunityID', "");
            localStorage.setItem('OpportunityID', OpportunityID);
            localStorage.setItem('HasRecordUpdated', "0");
            setSelectedId(OpportunityID);
            setIsModalOpen(true);
        }
    };

    const handleDeleteClick = async (event) => {
        event.stopPropagation(); // Prevent the row click event
        if (multipleIds.length > 0) {
            Swal.fire({
                title: 'Are you sure?',
                text: `You are about to delete ${multipleIds.length} record(s). This cannot be undone!`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: t('deleteConfirmBtn')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await OppurtunityService.DeleteOppurtunity(multipleIds);
                        setMultipleIds([]);
                        fetchOpportunity("0", pageSize);
                        setSelectedId("0");
                        Swal.fire(
                            t('deleted'),
                            t('deleteSuccess'),
                            'success'
                        );
                    } catch (error) {
                        console.error('Error deleting job:', error);
                        Swal.fire(
                            'Error!',
                            'There was a problem deleting the record.',
                            'error'
                        );
                    }
                }
            });
        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to delete asset.',
                'warning'
            );
        }
    };
    const handleCheckboxChange = (event, id) => {
        event.stopPropagation();
        setSelectedId((prevSelectedId) => (prevSelectedId === id ? "0" : id)); // Toggle selection
        setMultipleIds((prevSelectedIds) => {
            if (event.target.checked) {
                return [...prevSelectedIds, id];
            } else {
                return prevSelectedIds.filter((selectedId) => selectedId !== id);
            }
        });
    };
    const [lastCheckedIndex, setLastCheckedIndex] = useState(null);
    const handleCheckboxClick = (event, id, index) => {
        event.stopPropagation();

        const isChecked = event.target.checked;

        if (event.shiftKey && lastCheckedIndex !== null) {
            const start = Math.min(lastCheckedIndex, index);
            const end = Math.max(lastCheckedIndex, index);
            const idsInRange = opportunityList.slice(start, end + 1).map(l => l.ID);

            setMultipleIds(prev => {
                const s = new Set(prev);
                if (isChecked) {
                    idsInRange.forEach(x => s.add(x));     // range select
                } else {
                    idsInRange.forEach(x => s.delete(x));  // range unselect
                }
                return Array.from(s);
            });
        } else {
            // normal single toggle
            setMultipleIds(prev => {
                const s = new Set(prev);
                if (isChecked) s.add(id); else s.delete(id);
                return Array.from(s);
            });
        }

        // Always update the anchor index
        setLastCheckedIndex(index);
    };
    const fetchOpportunityDetail = async (OpportunityID) => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const LeadDetail = await OppurtunityService.GetOppurtunityByID(redirectCallback, OpportunityID);
            return LeadDetail[0];

        } catch (error) {
            console.error('Error fetching asset details:', error);
        }
    };
    const handleCreateCustomer = async (event) => {
        setLoading(true);
        try {
            if (multipleIds.length > 0) {
                const result = await Swal.fire({
                    title: 'Are you sure?',
                    text: "Create Customer from the Selected Opportunity!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Create it!'
                });
                if (result.isConfirmed) {
                    let message = ""
                    for (const id of multipleIds) {
                        message = await CreateCustomer(event, id, "0");
                    }
                    debugger;
                    if (message.message == "Data saved successfully") {
                        Swal.fire(
                            'Success!',
                            'Customer Created Successfully.',
                            'warning'
                        );
                        await OppurtunityService.DeleteOppurtunity(multipleIds);
                        setMultipleIds([]);
                        fetchOpportunity("0", pageSize);
                        setSelectedId("0");
                    }

                }
            }
            else {
                Swal.fire(
                    'Error!',
                    'Please check at least one record to create a Opportunity.',
                    'warning'
                );
            }
        } catch (error) {
            console.error('Error Creating Opportunities:', error);
        }
        finally {
            setLoading(false); // Stop loading after fetching
        }

    };
    const redirecttoUnAuthorzied = () => {
        navigate('/Unauthorized'); // Redirect to the login page
    };

    const handlePageChange = (page) => {
        setOppurtunityData([]);
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);

        }
    };
    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page
        setOppurtunityData([]); // Clear previous data
        const query = searchQuery.toLowerCase(); // Use current searchQuery state

        let columnsToSearch = searchColumns.length > 0
            ? searchColumns.join(",")
            : "ALL";

        setSearchOptions(columnsToSearch);

        const leadData = await OppurtunityService.GetAllOppurtunities(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), emailName.toString(), columnsToSearch.toString());
        setOppurtunityData(leadData);

        const leadCount = await OppurtunityService.GetOpportunityCount(redirectCallback, searchQuery, emailName.toString(), columnsToSearch.toString());
        setPOCount(leadCount[0].TotalRecords);
        setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize)); // Set total pages dynamically

        const searchList = await CustomerService.GetSearchLog("18");
        setRecentSearches(searchList);
    };
    const handleSort = async (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);

        setSortConfig({ key, direction });
        const porderData = await OppurtunityService.GetAllOppurtunities(redirectCallback, "1", pageSize.toString(),
            searchQuery.toString(), key.toString(), direction.toString(), emailName.toString(), searchColumns.toString());

        const porderCount = await OppurtunityService.GetOpportunityCount(redirectCallback, searchQuery, emailName.toString(), searchColumns.toString());

        setPOCount(porderCount[0].TotalRecords);
        setOppurtunityData(porderData);

        setTotalPages(Math.ceil(porderCount[0].TotalRecords / pageSize));
    };
    const IsModuleAssigned = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const CompanyID = localStorage.getItem("CompanyID");
            if (CompanyID === null || CompanyID === "null") {
                redirectCallback();
            }
            const Modules = await ModuleService.GetModuleByClientID(CompanyID, "18");
            if (Modules.length === 0) {
                Swal.fire(
                    'UnAuthorzied Access!',
                    'Sorry, You are not authorized to access this module.',
                    'warning'
                );
                redirecttoUnAuthorzied();
            }
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const handleEmailClick = async (event, opportunity) => {
        event.stopPropagation();
        setEmail(opportunity.vc_Email);
        setOpportunityIDForEmail(opportunity.ID)
        setIsEmailModalOpen(true);
    };
    const handleCloseEmailModal = async () => {
        setIsEmailModalOpen(false);
        setIsMultipleEmailModalOpen(false);
        fetchOpportunity("0", pageSize);
    };

    const defaultColumns = [
        "vc_Company",
        "vc_Topic",
        "dec_Weight",
        "vc_County",
        "vc_Title",
        "vc_Phone",
        "vc_Mobile",
        "vc_Email",
        "StatusName",
        "SourceName",
        "JobRole",
        "Industry",
        "ModifiedBy",
        "AssignTo",
        "vc_Category",
        "CreatedDate"
    ];

    const columnOptions = [
        { value: "vc_Company", label: "Company" },
        { value: "vc_Topic", label: "Product/Service Interest" },
        { value: "dec_Weight", label: "Weight" },
        { value: "vc_County", label: "County" },
        { value: "vc_Title", label: "Contact" },
        { value: "vc_Phone", label: "Phone" },
        { value: "vc_Mobile", label: "Mobile" },
        { value: "vc_Email", label: "Email" },
        { value: "StatusName", label: "Status" },
        { value: "SourceName", label: "Source" },
        { value: "JobRole", label: "Job Role" },
        { value: "UpdatedDate", label: "Updated Date" },
        { value: "AssignTo", label: "AssignTo" },
        { value: "vc_Category", label: "Category" },
        { value: "ModifiedBy", label: "ModifiedBy" },
        { value: "Industry", label: "Industry" },
        { value: "CreatedDate", label: "CreatedDate" }
    ];
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`OpportunityColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());

    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`OpportunityColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };



    const CreateCustomer = async (event, OpportunityID, quotationID) => {
        const LeadDetail = await fetchOpportunityDetail(OpportunityID);
        debugger;
        //  if (LeadDetail.ClientCompanyID < 1) {

        const formData = {
            ClientCompanyID: 0,
            FK_ClientCompanyType_ID: 0,
            ContactTypeID: "1",

            FK_LeadOpportunitySource_Id: LeadDetail.FK_LeadOpportunitySource_Id,
            FK_LeadOpportunityStatus_ID: LeadDetail.FK_LeadOpportunityStatus_ID,
            FK_TaxCode_ID: LeadDetail.FK_TaxCode_Id,
            FK_Currency_ID: LeadDetail.FK_Currency_Id,
            FK_Owner_Id: LeadDetail.FK_Owner_Id,
            TeamID: 0,
            CourierID: 0,
            CompanyName: LeadDetail.vc_Company,
            Title: LeadDetail.vc_Title,
            Forename: LeadDetail.vc_FirstName,
            Surname: LeadDetail.vc_Surname,
            Telephone: LeadDetail.vc_Phone,
            Mobile: LeadDetail.vc_Mobile,
            Email: LeadDetail.vc_Email,
            Address1: LeadDetail.vc_Address1,
            Address2: LeadDetail.vc_Address2,
            Address3: LeadDetail.vc_Address3,
            City: LeadDetail.vc_City,
            County: LeadDetail.vc_County,
            Country: LeadDetail.vc_Country,
            Website: LeadDetail.vc_Website,
            dec_Weight: LeadDetail.dec_Weight,
            vc_Topic: LeadDetail.vc_Topic,
            quotationID: quotationID,
            IndustrialSector: LeadDetail.IndustrialSector,
            NoOfEmployees: LeadDetail.NoOfEmployees,
            PostCode: LeadDetail.vc_Postcode,
            JobRoleID: LeadDetail.JobRoleID,
            AssignTo: LeadDetail.AssignTo,
            vc_Category: LeadDetail.vc_Category,
            LinkedIn: LeadDetail.LinkedIn

        }

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        formData.FromOpportunity = "1";
        formData.OpportunityID = OpportunityID;
        const formDataWithParts = {
            formData: formData,
            tableData: [],

        };
        const message = await handleSubmit(event, formDataWithParts, "", setErrors, redirectCallback, "");
        return message;
        //    }
        //    else {
        //        const ConvertingData = await CustomerService.ConvertCustomerDetail(LeadDetail.ClientCompanyID, OpportunityID, quotationID)
        //       return ConvertingData.message;
        //    }
    }
    const handleExportExcel = async () => {
        if (multipleIds.length === 0) {
            Swal.fire(
                'Warning!',
                'Please select at least one record to export.',
                'warning'
            );
            return;
        }
        setLoading(true);
        try {
            const selectedLeads = opportunityList.filter(oppor =>
                multipleIds.includes(oppor.ID)
            );
            if (!selectedLeads || selectedLeads.length === 0) {
                Swal.fire(
                    'Warning!',
                    'No data to export.',
                    'warning'
                );
                return;
            }
            const fields = await ImportTableService.GetAllImportFields(redirectCallback, "41");
            if (!fields || fields.length === 0) {
                Swal.fire(
                    'Warning!',
                    'No field definitions found for export.',
                    'warning'
                );
                return;
            }
            const headers = fields.map(field => field.vc_DisplayName || field.vc_FieldName || field);
            const rows = selectedLeads.map(row =>
                fields.map(field => {
                    const col = field.vc_FieldName || field; // Key name in row object
                    let value = row[col];

                    // Special handling for full name concatenation
                    if (col === "FK_LeadOpportunitySource_Id") {
                        value = `${row.SourceName ?? ""}`;
                    }
                    if (col === "FK_LeadOpportunityStatus_ID") {
                        value = `${row.StatusName ?? ""}`;
                    }
                    if (col === "Industry") {
                        value = `${row.vc_Category ?? ""}`;
                    }
                    if (col === "Category") {
                        value = `${row.IndustrialSector ?? ""}`;
                    }
                    if (col === "vc_Country") {
                        value = `${row.vc_CountryName ?? ""}`;
                    }
                    if (col === "JobRoleID") {
                        value = `${row.JobRole ?? ""}`;
                    }



                    // Format value safely for CSV
                    return `"${(value ?? '').toString().replace(/"/g, '""')}"`;
                }).join(',')
            );

            const csvContent = [
                headers.join(','), // CSV Header
                ...rows            // CSV Rows
            ].join('\n');

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'OpportunityList.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        catch (error) {
            console.error('Error fetching Teams:', error);
        }
        finally {
            setLoading(false); // Stop loading after fetching
        }
    };
    const handleSendMultipleEmail = async () => {
        if (multipleIds.length > 0) {

            const emails = multipleIds
                .map(id => {
                    const contact = opportunityList.find(c => c.ID === id);
                    return contact ? contact.vc_Email : '';
                })
                .filter(email => email);
            setMultipleEmails(emails);
            setIsMultipleEmailModalOpen(true);

        }
        else {
            Swal.fire(
                'Error!',
                'Please select at least one record to send email.',
                'error'
            );
        }
    }

    const [showColumnModal, setShowColumnModal] = useState(false);
    const handleAssignToUser = async (event) => {
        event.preventDefault();
        if (multipleIds.length === 0) {
            Swal.fire("Error", "Please select at least one record.", "warning");
            setSelectedUser(""); // reset dropdown
            return;
        }

        try {

            setShowColumnModal(true);
        } catch (error) {
            console.error("Error assigning user:", error);
            Swal.fire("Error", "Failed to assign records.", "error");
        } finally {
            setLoading(false);
        }
    };
    const handleddlAssignToUser = async (userId) => {
        if (multipleIds.length === 0) {
            Swal.fire("Error", "Please select at least one record.", "warning");
            setSelectedUser(""); // reset dropdown
            return;
        }

        try {
            setLoading(true);
            await LeadService.AssignLeadToUser(multipleIds, userId, "Opportunity");
            Swal.fire("Success", "Records assigned successfully.", "success");
            setMultipleIds([]); // clear selection
            setSelectedUser(""); // reset dropdown
            setShowColumnModal(false);
            fetchOpportunity("0", pageSize);
        } catch (error) {
            console.error("Error assigning user:", error);
            Swal.fire("Error", "Failed to assign records.", "error");
        } finally {
            setLoading(false);
        }
    };

    const [isEmailingModalOpen, setIsEmailingModalOpen] = useState(false);
    const [emailingName, setEmailingName] = useState("");
    const [isCustomerEmailing, setIsCustomerEmailing] = useState(false);
    const handleEmailing = async () => {
        if (multipleIds.length === 0) {
            Swal.fire('Warning!', 'Please select at least one record.', 'warning');
            return;
        }
        setIsEmailingModalOpen(true); // open the modal instead of calling the API directly
    };
    const handleConfirmEmailing = async () => {
        if (!emailingName.trim()) {
            Swal.fire('Warning!', 'Please enter a name.', 'warning');
            return;
        }

        try {
            await CustomerService.AddEmailing(multipleIds, "18", emailingName);
            setMultipleIds([]);

            setSelectedId("0");
            Swal.fire('Success!', `${multipleIds.length} record(s) have been saved successfully.`, 'success');
        } catch (error) {
            Swal.fire('Error!', 'Failed to save record.', 'error');
        } finally {
            setIsEmailingModalOpen(false);
            setEmailingName("");
        }
    };
    const handleEmailingList = async () => {
        setIsCustomerEmailing(true);
    }
    const handleCloseEmailListModal = async () => {
        setIsCustomerEmailing(false);
    };
    const handleSelect = async (EmailingName) => {
        setEmailName(EmailingName);
        setIsCustomerEmailing(false);
        setCurrentPage(1); // Reset to first page
        setOppurtunityData([]); // Clear previous data
        const query = searchQuery.toLowerCase();
        const leadData = await OppurtunityService.GetAllOppurtunities(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), EmailingName.toString(), searchColumns.toString());
        setOppurtunityData(leadData);

        const leadCount = await OppurtunityService.GetOpportunityCount(redirectCallback, searchQuery, EmailingName.toString(), searchColumns.toString());
        setPOCount(leadCount[0].TotalRecords);
        setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize));
    };
    const handleReset = async () => {
        setEmailName("");
        setIsCustomerEmailing(false);
        setCurrentPage(1); // Reset to first page
        setOppurtunityData([]); // Clear previous data
        const query = searchQuery.toLowerCase();
        const leadData = await OppurtunityService.GetAllOppurtunities(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), "", searchColumns.toString());
        setOppurtunityData(leadData);

        const leadCount = await OppurtunityService.GetOpportunityCount(redirectCallback, searchQuery, "", searchColumns.toString());
        setPOCount(leadCount[0].TotalRecords);
        setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize));
    };
    const handleUnAssignToUser = async (userId) => {
        if (multipleIds.length === 0) {
            Swal.fire("Error", "Please select at least one record.", "warning");
            setSelectedUser(""); // reset dropdown
            return;
        }

        try {
            setLoading(true);
            await LeadService.UnAssignLeadToUser(multipleIds, "Opportunity");
            Swal.fire("Success", "Records unassigned successfully.", "success");
            setMultipleIds([]); // clear selection
            setSelectedUser(""); // reset dropdown
            fetchOpportunity("0", pageSize);
        } catch (error) {
            console.error("Error assigning user:", error);
            Swal.fire("Error", "Failed to assign records.", "error");
        } finally {
            setLoading(false);
        }
    };
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [imageData, setImageData] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [reportTitle, setReportTitle] = useState('');
    const [reportLink, setReportLink] = useState('');
    const [inputValues, setInputValues] = useState({});
    const [outputData, setOutputData] = useState([]);
    const [error, setError] = useState(null);
    const getMergedPDFBytes = async (id) => {
        try {
            const currentInputValues = {
                ClientID: localStorage.getItem("CompanyID"),
                ID: id
            };
            const redirectCallback = () => navigate('/');

            let reportData = await ReportService.GetCompanyReports(redirectCallback, "18");
            reportData = reportData.filter(x => x.IsDefault.toString() === "1");

            const reportID = reportData.length > 0 ? reportData[0].ID : 113;
            const JasperReport = await JasperReportService.GetJasperReportByID(reportID);

            const queryObjMain = {
                ...currentInputValues,
                format: 'pdf',
                ReportName: JasperReport[0].ReportName,
                ReportType: JasperReport[0].ReportType,
                name: JasperReport[0].ReportName
            };

            const responseMain = await axiosInstance.get(
                `/Dashboard/ProxyReport?${new URLSearchParams(queryObjMain)}`,
                { responseType: 'blob' }
            );

            const mainPdfBytes = await responseMain.data.arrayBuffer();

            const pdfDoc = await PDFDocument.load(mainPdfBytes);

            return pdfDoc;

        } catch (err) {
            console.error(err);
            return null;
        }
    };
    const handlePrintUser = async (event) => {
        event.stopPropagation();


        setLoading(true);
        const includeTerms = false;

        if (multipleIds.length > 0) {
            try {
                const finalMergedPdf = await PDFDocument.create();

                // ================= MERGE INVOICES =================
                for (const id of multipleIds) {

                    const pdfDoc = await getMergedPDFBytes(id);

                    if (!pdfDoc) continue;

                    const pages = await finalMergedPdf.copyPages(
                        pdfDoc,
                        pdfDoc.getPageIndices()
                    );

                    pages.forEach(page => finalMergedPdf.addPage(page));
                }

                const finalBytes = await finalMergedPdf.save();
                const finalBlob = new Blob([finalBytes], { type: "application/pdf" });

                const finalUrl = URL.createObjectURL(finalBlob);
                setLoading(false);
                setPdfUrl(finalUrl);
                setShowPdfModal(true);

            } catch (err) {
                console.error('Error executing report:', err);
                setError('Failed to execute the report.');
            }
        } else {
            Swal.fire(
                'Error!',
                'Please check at least one record to print job.',
                'warning'
            );
        }
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }

    const defaultColumnsForSearch = [
        "vc_Company",
        "vc_Topic",
        "dec_Weight",
        "vc_County",
        "vc_Title",
        "vc_Phone",
        "vc_Mobile",
        "vc_Email",
        "StatusName",
        "SourceName",
        "JobRole",
        "Industry",
        "ModifiedBy",
        "AssignTo",
        "vc_Category",
        "CreatedDate"
    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnSearchOptions = [
        { value: "vc_Company", label: "Company" },
        { value: "vc_Topic", label: "Product/Service Interest" },
        { value: "dec_Weight", label: "Weight" },
        { value: "vc_County", label: "County" },
        { value: "vc_Title", label: "Contact" },
        { value: "vc_Phone", label: "Phone" },
        { value: "vc_Mobile", label: "Mobile" },
        { value: "vc_Email", label: "Email" },
        { value: "StatusName", label: "Status" },
        { value: "SourceName", label: "Source" },
        { value: "JobRole", label: "Position" },
        { value: "AssignTo", label: "AssignTo" },
        { value: "vc_Category", label: "Category" },
        { value: "ModifiedBy", label: "ModifiedBy" },
        { value: "Industry", label: "Industry" },
        { value: "CreatedDate", label: "CreatedDate" }
    ];
    const handleSearchColumnChange = (selectedOptions) => {
        setSearchColumns(selectedOptions);

    };

    const [inboxModalOpen, setInboxModalOpen] = useState(false);
    const handleInboxEmail = async (event) => {
        if (multipleIds.length > 0) {
            event.preventDefault();
            setInboxModalOpen(true);
        }
        else {
            Swal.fire(
                'Error!',
                'Please check at least one record to process.',
                'warning'
            );
        }
    }
    const handleCloseInbox = () => {
        setInboxModalOpen(false);
    };
    const handleInboxSave = async (selectedEmails) => {
        const LeadID = multipleIds[0];
        const reponse = await LeadService.CreateCommuncationInbox(selectedEmails, LeadID, "Opportunity");
        if (reponse.message == "Record saved successfully") {
            Swal.fire(
                'Success!',
                'Your record has been saved.',
                'success'
            );
        }
    };

    const getInitialWidths = () => {
        const saved = Cookies.get(`OpporColumnWidths_${CompanyID}_${UserID}`);
        const defaults = {};

        visibleColumns.forEach(col => {
            defaults[col] = 110;
        });

        if (!saved) return defaults;

        const parsed = JSON.parse(saved);
        const applied = {};

        visibleColumns.forEach(col => {
            applied[col] = parsed[col] || 110;
        });

        return applied;
    };

    const [columnWidths, setColumnWidths] = useState(getInitialWidths);
    const startX = useRef(0);
    const startWidth = useRef(0);
    const resizingColumn = useRef(null);
    const MIN_COL_WIDTH = 60;

    /**
     * Load widths from cookie when visibleColumns changes
     */
    useEffect(() => {
        const savedWidths = Cookies.get(`OpporColumnWidths_${CompanyID}_${UserID}`);
        if (savedWidths) {
            const parsed = JSON.parse(savedWidths);
            setColumnWidths((prev) => ({
                ...prev,
                ...parsed
            }));
        }
    }, [opportunityList]);


    /**
     * Start Column Resize
     */
    const startResize = (e, key) => {
        e.stopPropagation();
        startX.current = e.clientX;
        resizingColumn.current = key;

        const th = e.target.closest("th");   // FIXED HERE
        startWidth.current = th.offsetWidth;

        document.addEventListener("mousemove", resizeColumn);
        document.addEventListener("mouseup", stopResize);
    };

    /**
     * Resize Column dynamically
     */
    const resizeColumn = (e) => {
        if (!resizingColumn.current) return;

        const delta = e.clientX - startX.current;
        const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

        setColumnWidths(prev => ({
            ...prev,
            [resizingColumn.current]: newWidth
        }));
    };
    useEffect(() => {
        setColumnWidths(getInitialWidths());
    }, [visibleColumns]);

    /**
     * Stop resizing and save to cookie
     */
    const stopResize = () => {
        document.removeEventListener("mousemove", resizeColumn);
        document.removeEventListener("mouseup", stopResize);

        const key = resizingColumn.current;
        if (key) {
            setColumnWidths(prev => {
                // Save using the most recent updated state
                Cookies.set(
                    `OpporColumnWidths_${CompanyID}_${UserID}`,
                    JSON.stringify(prev),
                    { expires: 365 }
                );
                return prev;
            });
        }

        resizingColumn.current = null;
    };


    /**
     * Auto-fit column width
     */
    const autoFitColumn = (key) => {
        const cells = document.querySelectorAll(`[data-col='${key}']`);
        let maxWidth = 0;

        cells.forEach(cell => {
            maxWidth = Math.max(maxWidth, cell.scrollWidth);
        });

        const newWidth = maxWidth + 20;

        const updated = { ...columnWidths, [key]: newWidth };

        setColumnWidths(updated);

        Cookies.set(
            `OpporColumnWidths_${CompanyID}_${UserID}`,
            JSON.stringify(updated),
            { expires: 365 }
        );
    };
    const handleSyncInboxEmail = async (event) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `You are about to sync inbox emails`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await LeadService.SyncInboxEmail();
                    if (response.message === "Record saved successfully") {
                        Swal.fire(
                            'Success!',
                            'Your request for syning the inbox email is process successfully.',
                            'success'
                        );
                    }
                } catch (error) {

                    Swal.fire(
                        'Error!',
                        'There was a problem syncing the record.',
                        'error'
                    );
                }
            }
        });
    }
    return (
        <div>

            <Common showAddButton={'yes'} handleAddTask={handleCreateOpportunityClick}
                showDeleteButton={'yes'} handleDeleteItem={handleDeleteClick} ModuleID={"18"}
                showCreateCustomer={'yes'} handleCreateCustomer={handleCreateCustomer}
                showExportButton={'yes'} handleExportExcel={handleExportExcel}
                showEmailButton={'yes'} handleSendEmail={handleSendMultipleEmail}
                showSendEmailing={'yes'} handleEmailing={handleEmailing}
                showEmailingList={'yes'} handleEmailingList={handleEmailingList}
                showResetEmailingList={'yes'} handleReset={handleReset}
                showUnAssignUser={'yes'} handleUnAssignToUser={handleUnAssignToUser}
                showAssignUser={'yes'} handleAssignToUser={handleAssignToUser}
                showInboxEmail={'yes'} handleInboxEmail={handleInboxEmail}
                showSyncInboxEmail={'yes'} handleSyncInboxEmail={handleSyncInboxEmail}
                assignmentTitle="Manage Opp..." titleBar="Manage Opportunities"
                isDisabled={multipleIds.length > 1}
                showPrintUser={'yes'} handlePrintUser={handlePrintUser}
                HelpFormName="Opportunity List" HelpModule="34"
                RecordID={multipleIds}
            />

            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}


            <div className="main-content-header">
                <div className="row align-items-center">
                    <div className="col-xl-2">
                        <h1>{t('opportunityList')}</h1>
                    </div>



                    <div className="col-xl-10 d-flex justify-content-end">
                        <div className="col-sm-2">

                        </div>
                        <div className="col-sm-2 d-flex">

                        </div>
                        <ColumnOptionDropDown
                            options={columnOptions}
                            selectedOptions={visibleColumns}
                            onChange={handleColumnChange}
                        />

                    </div>
                </div>
            </div>


            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">

                            <div className="table-responsive" style={{ overflow: "visible" }}>
                                <div className="row mb-3">
                                    <div className="col-sm-1">
                                        <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                            <option value={500}>500</option>
                                            <option value={1000}>1000</option>
                                        </select>
                                    </div>
                                    <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                                    <div className="col-sm-6"></div>
                                    <div className="col-sm-1 d-flex align-items-center justify-content-end">
                                        <span className="me-2">Search</span>

                                        <MultiSearchDropDown
                                            options={columnSearchOptions}
                                            selectedOptions={searchColumns}
                                            onChange={handleSearchColumnChange}
                                        />
                                    </div>
                                    <div className="col-sm-2 d-flex justify-content-end">
                                        <input
                                            list="recent-searches"
                                            type="text"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            className="form-control me-2"
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleSearchButtonClick();
                                                }
                                            }}
                                        />
                                        <datalist id="recent-searches">
                                            {recentSearches.map((item, idx) => (
                                                <option key={idx} value={item.SearchQuery} />
                                            ))}
                                        </datalist>
                                        <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                                            <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                                        </button>
                                    </div>



                                </div>
                                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                                    <table
                                        style={{
                                            tableLayout: "fixed",
                                            width: "max-content",
                                            minWidth: "100%"
                                        }}
                                        className="table m-0 table-hover"
                                        ref={tableRef}
                                    >
                                        <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                                            <tr>
                                                <th
                                                    className="checkbox-header"
                                                    style={{
                                                        width: "40px",
                                                        minWidth: "40px",
                                                        maxWidth: "40px",
                                                        position: "sticky",
                                                        left: 0,
                                                        zIndex: 5,

                                                    }}
                                                ></th>
                                                {visibleColumns.includes("vc_Company") && <th onClick={() => handleSort('ClientCompanyID')}
                                                    style={{
                                                        width: `${columnWidths?.vc_Company}px`,
                                                        minWidth: `${MIN_COL_WIDTH}px`
                                                    }}
                                                    className="resizable ellipsis">{t('companyName')}
                                                    <i
                                                        className={`ms-1 icofont ${sortConfig.key === 'ClientCompanyID'
                                                            ? sortConfig.direction === 'asc'
                                                                ? 'icofont-caret-up'
                                                                : 'icofont-caret-down'
                                                            : 'icofont-sorting'
                                                            }`}
                                                    ></i>
                                                    <div
                                                        className="resize-handle"
                                                        onMouseDown={(e) => {
                                                            e.stopPropagation();   // STOP the click event from bubbling
                                                            startResize(e, "vc_Company");
                                                        }}
                                                        onDoubleClick={() => autoFitColumn("vc_Company")}
                                                    />
                                                </th>
                                                }
                                                {visibleColumns.includes("vc_Topic") &&
                                                    <th onClick={() => handleSort('vc_Topic')}
                                                        style={{
                                                            width: `${columnWidths?.vc_Topic}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">Product/Service Interest
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'vc_Topic'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "vc_Topic");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("vc_Topic")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("dec_Weight") &&
                                                    <th onClick={() => handleSort('dec_Weight')}
                                                        style={{
                                                            width: `${columnWidths?.dec_Weight}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">{t('weight')}
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'dec_Weight'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "dec_Weight");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("dec_Weight")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("vc_County") &&
                                                    <th onClick={() => handleSort('vc_County')}
                                                        style={{
                                                            width: `${columnWidths?.vc_County}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">{t('county')}
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'vc_County'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "vc_County");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("vc_County")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("vc_Title") &&
                                                    <th onClick={() => handleSort('vc_Title')}
                                                        style={{
                                                            width: `${columnWidths?.vc_Title}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">{t('contactName')}
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'vc_Title'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "vc_Title");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("vc_Title")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("vc_Phone") &&
                                                    <th onClick={() => handleSort('vc_Phone')}
                                                        style={{
                                                            width: `${columnWidths?.vc_Phone}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">{t('telephone')}
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'vc_Phone'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "vc_Phone");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("vc_Phone")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("vc_Mobile") &&
                                                    <th onClick={() => handleSort('vc_Mobile')}
                                                        style={{
                                                            width: `${columnWidths?.vc_Mobile}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">{t('mobile')}
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'vc_Mobile'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "vc_Mobile");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("vc_Mobile")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("vc_Email") &&
                                                    <th onClick={() => handleSort('vc_Email')}
                                                        style={{
                                                            width: `${columnWidths?.vc_Email}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">{t('email')}
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'vc_Email'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "vc_Email");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("vc_Email")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("StatusName") &&
                                                    <th onClick={() => handleSort('StatusName')}

                                                        style={{
                                                            width: `${columnWidths?.StatusName}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">{t('status')}
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'StatusName'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "StatusName");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("StatusName")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("SourceName") &&
                                                    <th onClick={() => handleSort('SourceName')}

                                                        style={{
                                                            width: `${columnWidths?.SourceName}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">{t('source')}
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'SourceName'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "SourceName");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("SourceName")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("vc_Category") &&
                                                    <th onClick={() => handleSort('vc_Category')}
                                                        style={{
                                                            width: `${columnWidths?.vc_Category}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">Category
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'vc_Category'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "vc_Category");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("vc_Category")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("JobRole") &&
                                                    <th onClick={() => handleSort('JobRoleID')}

                                                        style={{
                                                            width: `${columnWidths?.JobRoleID}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">{t('JobRole')}
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'JobRoleID'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "JobRoleID");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("JobRoleID")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("Industry") &&
                                                    <th onClick={() => handleSort('Industry')}
                                                        style={{
                                                            width: `${columnWidths?.Industry}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">Industry
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'Industry'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "Industry");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("Industry")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("AssignTo") &&
                                                    <th onClick={() => handleSort('AssignTo')}

                                                        style={{
                                                            width: `${columnWidths?.AssignTo}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">Assign To
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'AssignTo'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "AssignTo");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("AssignTo")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("ModifiedBy") &&
                                                    <th onClick={() => handleSort('ModifiedBy')}
                                                        style={{
                                                            width: `${columnWidths?.ModifiedBy}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">Modified By
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'ModifiedBy'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "ModifiedBy");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("ModifiedBy")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("UpdatedDate") &&
                                                    <th onClick={() => handleSort('UpdatedDate')}

                                                        style={{
                                                            width: `${columnWidths?.UpdatedDate}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">Last Action
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'UpdatedDate'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "UpdatedDate");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("UpdatedDate")}
                                                        />
                                                    </th>
                                                }
                                                {visibleColumns.includes("CreatedDate") &&
                                                    <th onClick={() => handleSort('CreatedDate')}

                                                        style={{
                                                            width: `${columnWidths?.CreatedDate}px`,
                                                            minWidth: `${MIN_COL_WIDTH}px`
                                                        }}
                                                        className="resizable ellipsis">Created Date
                                                        <i
                                                            className={`ms-1 icofont ${sortConfig.key === 'CreatedDate'
                                                                ? sortConfig.direction === 'asc'
                                                                    ? 'icofont-caret-up'
                                                                    : 'icofont-caret-down'
                                                                : 'icofont-sorting'
                                                                }`}
                                                        ></i>
                                                        <div
                                                            className="resize-handle"
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();   // STOP the click event from bubbling
                                                                startResize(e, "CreatedDate");
                                                            }}
                                                            onDoubleClick={() => autoFitColumn("CreatedDate")}
                                                        />
                                                    </th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {opportunityList.map((lead, index) => (

                                                <tr key={lead.ID}
                                                    onClick={() => handleEditClick(lead.ID)}
                                                    style={{
                                                        backgroundColor: selectedId.toString() === lead.ID.toString() ? 'rgb(197, 218, 237)' : '', // Highlight background
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    <td
                                                        className="checkbox-cell"
                                                        onClick={(e) => e.stopPropagation()}
                                                        style={{
                                                            width: "40px",
                                                            minWidth: "40px",
                                                            maxWidth: "40px",
                                                            position: "sticky",
                                                            left: 0,
                                                            zIndex: 3,
                                                            backgroundColor:
                                                                selectedId.toString() === lead.ID.toString()
                                                                    ? 'rgb(197, 218, 237)'
                                                                    : '#fff'
                                                        }}
                                                    >
                                                        <div
                                                            className="checkbox-hover-area"
                                                            onClick={(event) => handleCheckboxClick(event, lead.ID, index)}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked={multipleIds.includes(lead.ID)}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </td>
                                                    {visibleColumns.includes("vc_Company") &&
                                                        <td style={{
                                                            width: columnWidths.vc_Company,
                                                            minWidth: MIN_COL_WIDTH,
                                                        }} className="no-wrap ellipsis" title={lead.CustomerName}>
                                                            {lead.CustomerName}

                                                        </td>
                                                    }
                                                    {visibleColumns.includes("vc_Topic") &&
                                                        <td style={{
                                                            width: columnWidths.vc_Topic,
                                                            minWidth: MIN_COL_WIDTH,
                                                        }} className="no-wrap ellipsis" title={lead.vc_Topic}>
                                                            {lead.vc_Topic}
                                                        </td>
                                                    }
                                                    {visibleColumns.includes("dec_Weight") &&
                                                        <td style={{
                                                            width: columnWidths.dec_Weight,
                                                            minWidth: MIN_COL_WIDTH,
                                                        }} className="no-wrap ellipsis" title={lead.dec_Weight}>

                                                            {lead.dec_Weight}
                                                        </td>
                                                    }
                                                    {visibleColumns.includes("vc_County") &&
                                                        <td style={{
                                                            width: columnWidths.vc_County,
                                                            minWidth: MIN_COL_WIDTH,
                                                        }} className="no-wrap ellipsis" title={lead.vc_County}>
                                                            {lead.vc_County}
                                                        </td>
                                                    }

                                                    {visibleColumns.includes("vc_Title") && <td style={{
                                                        width: columnWidths.vc_Title,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">{lead.vc_Title} {lead.vc_FirstName} {lead.vc_Surname}</td>}
                                                    {visibleColumns.includes("vc_Phone") && <td style={{
                                                        width: columnWidths.vc_Phone,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">
                                                        <a href={`tel:${lead.vc_Phone}`} onClick={(e) => e.stopPropagation()}>
                                                            {lead.vc_Phone}
                                                        </a>
                                                    </td>}
                                                    {visibleColumns.includes("vc_Mobile") && <td style={{
                                                        width: columnWidths.vc_Mobile,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">

                                                        <a href={`tel:${lead.vc_Mobile}`} onClick={(e) => e.stopPropagation()}>
                                                            {lead.vc_Mobile}
                                                        </a>
                                                    </td>}
                                                    {visibleColumns.includes("vc_Email") &&
                                                        <td style={{
                                                            width: columnWidths.vc_Email,
                                                            minWidth: MIN_COL_WIDTH,
                                                        }} className="no-wrap ellipsis" title={lead.vc_Email}>

                                                            <a href='#' onClick={(event) => handleEmailClick(event, lead)}>
                                                                {lead.vc_Email}
                                                            </a>
                                                        </td>
                                                    }
                                                    {visibleColumns.includes("StatusName") &&
                                                        <td style={{
                                                            width: columnWidths.StatusName,
                                                            minWidth: MIN_COL_WIDTH,
                                                        }} className="no-wrap ellipsis">{lead.StatusName} </td>}
                                                    {visibleColumns.includes("SourceName") && <td style={{
                                                        width: columnWidths.SourceName,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">{lead.SourceName} </td>}
                                                    {visibleColumns.includes("vc_Category") && <td style={{
                                                        width: columnWidths.vc_Category,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">{lead.IndustrialSector} </td>}
                                                    {visibleColumns.includes("JobRole") && <td style={{
                                                        width: columnWidths.JobRole,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">{lead.JobRole} </td>}
                                                    {visibleColumns.includes("Industry") && <td style={{
                                                        width: columnWidths.Industry,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">{lead.vc_Category} </td>}
                                                    {visibleColumns.includes("AssignTo") && <td style={{
                                                        width: columnWidths.AssignTo,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">
                                                        {lead.AssignTo ? (
                                                            <div
                                                                title={lead.AssignTo}
                                                                style={{
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    width: "25px",
                                                                    height: "25px",
                                                                    borderRadius: "50%",
                                                                    backgroundColor: "#007bff",
                                                                    color: "white",
                                                                    fontWeight: "bold",
                                                                    fontSize: "14px",
                                                                }}
                                                            >
                                                                {lead.AssignTo.split(" ")
                                                                    .map(word => word.charAt(0).toUpperCase())
                                                                    .join("")}
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </td>}
                                                    {visibleColumns.includes("ModifiedBy") && <td style={{
                                                        width: columnWidths.ModifiedBy,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">
                                                        {lead.ModifiedBy ? (
                                                            <div
                                                                title={lead.ModifiedBy}
                                                                style={{
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    width: "25px",
                                                                    height: "25px",
                                                                    borderRadius: "50%",
                                                                    backgroundColor: "#368938",
                                                                    color: "white",
                                                                    fontWeight: "bold",
                                                                    fontSize: "14px",
                                                                }}
                                                            >
                                                                {lead.ModifiedBy.split(" ")
                                                                    .map(word => word.charAt(0).toUpperCase())
                                                                    .join("")}
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </td>}
                                                    {visibleColumns.includes("UpdatedDate") && <td style={{
                                                        width: columnWidths.UpdatedDate,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">{formatDateWithFns(lead.UpdatedDate, activeDateFormat)}  </td>}
                                                    {visibleColumns.includes("CreatedDate") && <td style={{
                                                        width: columnWidths.CreatedDate,
                                                        minWidth: MIN_COL_WIDTH,
                                                    }} className="no-wrap ellipsis">{formatDateWithFns(lead.CreatedDate, activeDateFormat)}  </td>}
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                                            <tr>
                                                <td colSpan={visibleColumns.length + 1}>
                                                    <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                        Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                                                        {/* Last Page Button */}
                                                        <button
                                                            style={{ float: "right", marginLeft: "5px" }}
                                                            className='btn btn-info'
                                                            onClick={() => handlePageChange(totalPages)} // Navigate to last page
                                                            disabled={currentPage === totalPages}
                                                        >
                                                            <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} />   Last
                                                        </button>

                                                        {/* Next Page Button */}
                                                        <button
                                                            style={{ float: "right", marginLeft: "5px" }}
                                                            className='btn btn-info'
                                                            onClick={() => handlePageChange(currentPage + 1)}
                                                            disabled={currentPage === totalPages}
                                                        >
                                                            <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} /> Next
                                                        </button>

                                                        <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                                                            Page {currentPage} of {totalPages}
                                                        </span>

                                                        {/* Previous Page Button */}
                                                        <button
                                                            style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                                                            className='btn btn-info'
                                                            onClick={() => handlePageChange(currentPage - 1)}
                                                            disabled={currentPage === 1}
                                                        >
                                                            <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} />  Prev
                                                        </button>

                                                        {/* First Page Button */}
                                                        <button
                                                            style={{ float: "right" }}
                                                            className='btn btn-info'
                                                            onClick={() => handlePageChange(1)} // Navigate to first page
                                                            disabled={currentPage === 1}
                                                        >
                                                            <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} />  First
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>

                                </div>
                                {isEmailingModalOpen && (
                                    <div className="modal show fade" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
                                        <div className="modal-dialog">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Add Emailing Name</h5>
                                                    <button type="button" className="btn-close" onClick={() => setIsEmailingModalOpen(false)}></button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0px", "marginTop": "10px" }}>

                                                        <div className="col-sm-12">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter Name"
                                                                value={emailingName}
                                                                onChange={(e) => setEmailingName(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button className="btn btn-secondary" onClick={() => setIsEmailingModalOpen(false)}>Cancel</button>
                                                    <button className="btn btn-primary" onClick={handleConfirmEmailing}>Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {isModalOpen && (
                                    <OppurtunityDetailModal OpportunityID={localStorage.getItem('OpportunityID')} onClose={handleCloseModal} onSuccess={fetchOpportunity} IsDiaries={"0"} CommunicationID={"0"}
                                        onNext={handleNext} onPrevious={handlePrevious} />
                                )}
                                {isEmailModalOpen && (
                                    <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} Module="Opportunity" ModuleID={opportunityIDForEmail} />
                                )}
                                {isMultipleEmailModalOpen && (
                                    <MultipleEmail
                                        onClose={handleCloseEmailModal}
                                        ToEmail={multipleEmails} // remove empty strings
                                        Module="Opportunity"
                                        ModuleID={opportunityIDForEmail}
                                        MultipleIDs={multipleIds}
                                    />
                                )}
                                {isCustomerEmailing && (
                                    <CustomerEmailingList
                                        show={isCustomerEmailing}
                                        onClose={handleCloseEmailListModal}
                                        ModuleID={"18"}
                                        handleSelect={handleSelect}
                                        OnReset={handleReset}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            )}
            {showColumnModal && (
                <div
                    className="modal show fade"
                    style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Assign Engineer</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowColumnModal(false)}
                                ></button>
                            </div>

                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0px", "marginTop": "10px" }}>

                                    <div className="col-sm-12">
                                        {selectedRoleName === "Administrator" && (
                                            <UserDropdown
                                                value={selectedUser}
                                                onChange={(val) => {
                                                    setSelectedUser(val);
                                                    if (val) handleddlAssignToUser(val);
                                                }}
                                                showLabel={false}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowColumnModal(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {inboxModalOpen && (
                <InboxModal onSave={handleInboxSave} onClose={handleCloseInbox} />
            )}
        </div>
    );
}

export default LeadList;